export default {
      id: "action-item-project-created-usage",
      viewBox: "0 0 30 31",
      url: __webpack_public_path__ + "icons.svg#action-item-project-created",
      toString: function () {
        return this.url;
      }
    }